import { GridSortModel } from '@mui/x-data-grid-pro';

export const getSortFilter = (sortModel?: GridSortModel | null) => {
  if (!sortModel?.length) {
    return;
  }
  const [{ field: column, sort: order }] = sortModel;
  return { column, order };
};
